import classNames from "classnames";
import { FieldMessage, helpTextId } from "./FieldValue";
import { ComponentFieldProps } from "./ComponentField.types";

export function ComponentField<TProps extends object = object>({
  label,
  component: Component,
  componentProps,
  name,
  helpText,
  error,
  className = "",
}: ComponentFieldProps<TProps>) {
  return (
    <div className={classNames("field-value", className)}>
      <div className="field-value__label form-label">{label}</div>
      <Component {...(componentProps as TProps)} />
      {helpText && (
        <p
          id={helpTextId(name ?? "")}
          className="form-text small text-body-secondary mb-0"
        >
          {helpText}
        </p>
      )}
      <FieldMessage name={name ?? ""} error={error} />
    </div>
  );
}
